export const TestimonialsSection = () => {
  return (
    <section className="bg-slate-50 py-14">
      <div className="mx-auto max-w-6xl px-4 text-center sm:px-6">
        <h2 className="text-2xl font-bold text-slate-900">Depoimentos</h2>
        <p className="mt-3 text-sm text-slate-600">
          Em breve — cases reais de clientes após o go-live.
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-3">
          {[1, 2, 3].map((n) => (
            <div
              key={n}
              className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-sm text-slate-400"
            >
              Logo cliente {n}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
